import React, { useEffect, useState } from "react";
import UserInfoForm from "./UserInfoForm";
import { getUser } from "../../services/UserInfo";
import { UserProfile, newUserProfile } from "../../data/userProfile";
import { getSocialMediaInfo } from "../../services/socialMediaPlatformInformation";
import { SocialMediaPlatformInfo } from "../../data/socialMediaData";
import { drawerTabs as defaultDrawerTabs } from "../../data/account/accountData";
import Header from "../common/Header";
import SessionListPage from "./SessionListPage";
import { getUserSessions } from "../../services/userSessionInformation";
import { SessionInfo } from "../../data/SessionData";
import { useGlobal } from '../../utils/GlobalContext';
import { EventsListItem } from "../../data/eventInfo";
import { UserSessionEventData } from "../../data/UserSessionEventData";

export default function Account() {
  const [selectedMenuItem, setSelectedMenuItem] = useState("");
  const [userInfo, setUserInfo] = useState<UserProfile>(newUserProfile);
  const [socialMediaInfo, setSocialMediaInfo] = useState<SocialMediaPlatformInfo[]>([]);
  const [userSessionEvent, setUserSessionEvent] = useState<UserSessionEventData>();
  const [isSessionsLoading, setIsSessionsLoading] = useState(true); // Loading state
  const { state, dispatch } = useGlobal();
  const [userSessions, setUserSessions] = useState<SessionInfo[]>([]);
  const [events, setEvents] = useState<EventsListItem[]>([]);

  const CurrentId = state.UserProfile.Id.toString();

  useEffect(() => {
    if(state.UserProfile.RolesList.includes("User")) {
      const fetchSocialMediaInfo = async () => {
        try {
          const response = await getSocialMediaInfo();
          if (response && Array.isArray(response)) {
            setSocialMediaInfo(response);
          }
        } catch (err) {
          console.error("Failed to fetch social media information." + err);
        }
      };
      fetchSocialMediaInfo();
    }
  }, []);

  useEffect(() => {
    if(state.UserProfile.RolesList.includes("User") && state.UserProfile.IsExistingUser) {
      const fetchUserInfo = async () => {
        if (!CurrentId) {
          return;
        }
        try {
          const cinfo = await getUser(CurrentId);
          setUserInfo(cinfo);
        } catch (err) {
          console.error("Failed to fetch user information." + err);
        }
      };
      fetchUserInfo();
    }
  }, [CurrentId]);

  useEffect(() => {
    if(state.UserProfile.RolesList.includes("User")) {
      const fetchUserSessionsInfo = async () => {
        setIsSessionsLoading(true); // Begin loading
        try {
          const response = await getUserSessions(CurrentId);
          setUserSessions(response.UserSessions);
          setEvents(response.Events);
        } catch (err) {
          console.error("Failed to fetch user sessions.", err);
        }
        setIsSessionsLoading(false); // End loading
      };
      
    fetchUserSessionsInfo();
    }
  }, [CurrentId]);
 
  const handleMenuItemClick = (text: string) => {
    setSelectedMenuItem(text);
  };
  
  const handleUserInfoUpdate = async () => {
    const updatedUserInfo = await getUser(CurrentId);
    setUserInfo(updatedUserInfo);
  };

  const handleUpdateUserSession = async () => {
    setIsSessionsLoading(true); // Begin loading
    try {
      const response = await getUserSessions(CurrentId);
      if (response && Array.isArray(response)) {
        setUserSessionEvent(response);
      }
    } catch (err) {
      console.error("Failed to fetch user sessions.", err);
    }
    setIsSessionsLoading(false); // End loading
  };

  const renderComponent = () => {
    if (!state.UserProfile.IsExistingUser) {
      return <UserInfoForm
        userInfo={userInfo}
        socialMediaInfo={socialMediaInfo}
        CurrentId={CurrentId}
        onUserInfoUpdate={handleUserInfoUpdate}
        />;
    }
    switch (selectedMenuItem) {
      case "My Sessions":
        return <SessionListPage userSessions={userSessions} isLoading={isSessionsLoading} userId={CurrentId} events={events} onUserSessionUpdate={handleUpdateUserSession}/>;
      default:
        return <UserInfoForm
          userInfo={userInfo}
          socialMediaInfo={socialMediaInfo}
          CurrentId={CurrentId}
          onUserInfoUpdate={handleUserInfoUpdate}
        />;
    }
  };

  const drawerTabs = state.UserProfile.IsExistingUser
    ? defaultDrawerTabs
    : defaultDrawerTabs.filter(tab => tab !== 'My Sessions');
  return (
    <Header
      showDrawer={true}
      drawerTabs={drawerTabs}
      handleMenuItemClick={handleMenuItemClick}
      renderComponent={renderComponent}
    />
  );
}